<template>
    <UCard
        :ui="{
            root: 'flex min-h-0 flex-col overflow-hidden',
            body: 'flex min-h-0 flex-1 flex-col p-0 sm:p-0',
        }"
        class="surface-card overflow-hidden bg-card-primary p-0 rounded-lg"
    >
        <slot name="header"></slot>
        <p v-if="props.title?.length" class="shrink-0 px-4 pt-4 font-extrabold text-xl text-text-primary sm:px-6 sm:pt-6">{{ props.title }}</p>
        <p v-if="props.description" class="shrink-0 px-4 text-md text-text-secondary sm:px-6">{{ props.description }}</p>
        <hr v-if="props.title?.length" class="mx-4 mt-3 mb-5 shrink-0 border-[var(--ui-border-muted)] sm:mx-6">

        <div class="flex min-h-0 flex-1 flex-col">
            <slot></slot>
        </div>
    </UCard>
</template>

<script setup lang="ts">
    const props = defineProps<{
        title?: string;
        description?: string;
    }>();
</script>